<template>
  <div class="wrapper">
    <div class="animated fadeIn ">
      <div>
      <b-row>
        <b-col cols="12">
         <b-breadcrumb :items="breadcrumbs"/>
         <!-- Code added -->
          <b-card header-tag="header" footer-tag="footer" style=" margin-bottom: 0px;">
            <!-- <label style="margin-left: 20px;">All Designs : </label>         
            
             <hr style="height:30px"> -->


            <label style="padding-top: 10px!important; margin-left: 20px;">Available Brands :</label>                
          <b-row class="boxto"> 
           <b-col sm="6" lg="2" class="pointer">
                <router-link  :to="'/style_list/' +'Designs_Pending_For_Approval'">
                  <b-card no-body class="bg-aqua" style="height:125px !important">
                    <b-card-body class="pb-0">          
                      <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Proto Sampling pendin)" style="margin-top: 10%;" v-bind="Designs_Pending_For_Approval">{{Designs_Pending_For_Approval}}</h4>
                     <p class="text-center countcolor"  v-b-tooltip.hover title="Designs Pending For Approval">Designs Pending For Approval</p>
                    </b-card-body> 
                  </b-card>
                </router-link> 
            </b-col>

            <b-col sm="6" lg="2" class="pointer">

                <router-link  :to="'/style_list/' +'Designs_Approved'">
                  <b-card no-body class="bg-purpal" style="height:125px !important">
                    <b-card-body class="pb-0">          
                      <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Proto Sampling pendin)" style="margin-top: 10%;" v-bind="Designs_Approved">{{Designs_Approved}}</h4>
                     <p class="text-center countcolor"  v-b-tooltip.hover title="Designs Pending For Approval">Designs Approved</p>
                    </b-card-body> 
                  </b-card>
                </router-link> 
            </b-col>

            <b-col sm="6" lg="2" class="pointer">
                <router-link  :to="'/style_list/' +'Designs_Feedback'">
                  <b-card no-body class="bg-def" style="height:125px !important">
                    <b-card-body class="pb-0">          
                      <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Proto Sampling pendin)" style="margin-top: 10%;" v-bind="Designs_Feedback">{{Designs_Feedback}}</h4>
                     <p class="text-center countcolor"  v-b-tooltip.hover title="Designs Feedback">Designs Feedback</p>
                    </b-card-body> 
                  </b-card>
                </router-link> 
            </b-col>

            <b-col sm="6" lg="2" class="pointer">

                <router-link  :to="'/style_list/' +'Designs_Rejected'">

                  <b-card no-body class="bg-green" style="height:125px !important">
                    <b-card-body class="pb-0">          
                      <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Proto Sampling pendin)" style="margin-top: 10%;" v-bind="Designs_Rejected">{{Designs_Rejected}}</h4>
                     <p class="text-center countcolor"  v-b-tooltip.hover title="Designs Rejected">Designs Rejected</p>
                    </b-card-body> 
                  </b-card>
                </router-link>      
                
              </b-col>
            </b-row> 
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</div>
 
           
          
</template>


<script>

import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import auth from "@/utils/auth";
 import Router from 'vue-router'
const axios = require('axios');
export default {
  name: 'dashboard',
  data: function () {
    return {
      name: 'dashboard',
      id: '',
      Firstmile:[],
      Lasttmile:[],
      Reverse:[],
     a:-1,

    resultData:[],
    Designs_Pending_For_Approval: 0,
    Designs_Approved: 0,
    Designs_Feedback: 0,
    Designs_Rejected: 0,




       breadcrumbs: [{
        text: 'Dashboard',
        active: true
      }]
    }
  },
 
  created: function () {
    
    this.displayDashboardData();
  },

  methods: {
      displayDashboardData: function () {
         var userData = localStorage.getItem('userData');
          var userInfo = JSON.parse(userData);
          
            axios.post(`${CONSTANTS.API_URL}/getBrandwiseDashboardCountForFH`)
                .then(response => {
                 var result = response.data;
                  if (result.returnmsg === 'Successful') {
                    this.resultData = response.data.returnvalue[0];
                    console.log("ddddddddddddd",this.resultData)
                    if(this.resultData.Design_Styles.Designs_Pending_For_Approval=='' || this.resultData.Design_Styles.Designs_Pending_For_Approval==null || this.resultData.Design_Styles.Designs_Pending_For_Approval==undefined){
                      this.Designs_Pending_For_Approval= 0;
                    }
                    else{
                      this.Designs_Pending_For_Approval= this.resultData.Design_Styles.Designs_Pending_For_Approval
                    }

                    if(this.resultData.Design_Styles.Designs_Approved=='' || this.resultData.Design_Styles.Designs_Approved==null || this.resultData.Design_Styles.Designs_Approved==undefined){
                      this.Designs_Approved= 0;
                    }
                    else{
                      this.Designs_Approved= this.resultData.Design_Styles.Designs_Approved
                    }

                    if(this.resultData.Design_Styles.Designs_Feedback=='' || this.resultData.Design_Styles.Designs_Feedback==null || this.resultData.Design_Styles.Designs_Feedback==undefined){
                      this.Designs_Feedback= 0;
                    }
                    else{
                      this.Designs_Feedback= this.resultData.Design_Styles.Designs_Feedback
                    }

                    if(this.resultData.Design_Styles.Designs_Rejected=='' || this.resultData.Design_Styles.Designs_Rejected==null || this.resultData.Design_Styles.Designs_Rejected==undefined){
                      this.Designs_Rejected= 0;
                    }
                    else{
                      this.Designs_Rejected= this.resultData.Design_Styles.Designs_Rejected
                    }
     
                  }
                  else{
                    this.resultData=[];

                  }   
          //}
        
        })        
    }
  }
}

</script>

<style>
.bg-aqua{
      background-color: #00c0ef !important;
      color: #fff!important;
      width: 150px;
  height: 140px;
  margin-left: 20px;
}
.bg-green{
      background-color: #00a65a !important;
       color: #fff!important;
       width: 150px;
  height: 140px;
}
.bg-yellow{
      background-color: #f39c12 !important;
       color: #fff!important;
       width: 150px;
  height: 140px;
}
.bg-pink{
  background-color: #FF69B4 !important;
   color: #fff!important;
   width: 150px;
  height: 140px;
}
.bg-purpal{  
    background-color: #9370DB !important;
     color: #fff!important;
     width: 150px;
  height: 140px;
}
.bg-cyan{
      background-color: #008B8B !important;
       color: #fff!important;  
       width: 150px;
  height: 140px;
}
.bg-red{
      background-color: #dd4b39 !important;
       color: #fff!important;
       width: 150px;
  height: 140px;
}
.bg-def{
  background-color: #f09642 !important;
   color: #fff!important;
  width: 150px;
  height: 140px;
}
.boxto .card-body{
  padding: 0px!important;
}
.heading{
  padding: 12px 12px 5px 12px!important;
}
.countcolor
{
      color:white !important;

}
.pointer
{
  cursor: pointer!important;
}

</style>